/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.drawsParticipations.internal

import features.drawsParticipations.models.ParticipationsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.drawsParticipations.internal.DrawsParticipationsUseCase.Params

internal class DrawsParticipationsUseCase : AsyncUseCase<ParticipationsModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,

    )

    private val drawsParticipationsService: DrawsParticipationsService = DrawsParticipationsServiceImpl()

    override suspend fun run(params: Params): Result<ParticipationsModel> {
        return drawsParticipationsService.getDrawsParticipations(
            overrideHeaders = params.overrideHeaders,

        )
    }
}
